export {default as baseService} from "./baseService";
export {default as fraudService} from "./fraudService";
export {default as profileService} from "./profileService";
export {default as staticService} from "./staticService";
export { default as b2cService } from "./b2cService";
export {default as countriesService} from "./countriesService";
export {default as quoteService} from "./quoteService";
export  {default as giftCardService} from "./giftCardService"; 
export {default as relayService} from "./relayService";
